import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import or from "./locales/or/translation.json";
import en from "./locales/en/translation.json";
import am from "./locales/am/translation.json";

const supportedLanguages = ["or", "en", "am"];
const savedLanguage = localStorage.getItem("language") || "or";
const initialLanguage = supportedLanguages.includes(savedLanguage)
  ? savedLanguage
  : "or";

i18n.use(initReactI18next).init({
  resources: {
    or: { translation: or },
    en: { translation: en },
    am: { translation: am },
  },
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
